// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2jXzz{padding-top:8px}", ""]);
// Exports
exports.locals = {
	"navWrapper": "_2jXzz"
};
module.exports = exports;
